import { Card, CardBody, Col } from "reactstrap";
import { Link } from "react-router-dom";

export type StatWidgetProps = {
  title: string;
  value: string;
  subtext: string;
  icon: string;
  color: string;
  to?: string;
};

export function StatWidget({ title, value, subtext, icon, color, to }: StatWidgetProps) {
  const card = (
    <Card className="card-animate" style={to ? { cursor: "pointer" } : undefined}>
      <CardBody>
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <p className="text-uppercase fw-medium text-muted mb-0">{title}</p>
            <h4 className="fs-4 fw-semibold mt-1">{value}</h4>
            <p className="text-muted mb-0">
              <small>{subtext}</small>
            </p>
          </div>
          <div className={`avatar-sm flex-shrink-0 bg-${color}-subtle rounded`}>
            <span className={`avatar-title bg-${color} rounded fs-4`}>
              <i className={`ri-${icon}-line`} />
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  );

  return (
    <Col xl={3} md={6}>
      {to ? (
        <Link to={to} className="text-decoration-none text-reset d-block">
          {card}
        </Link>
      ) : (
        card
      )}
    </Col>
  );
}
